import { observer } from 'mobx-react-lite';
import { Col } from '../view.box';
import { FeedbackDrawerItem, FeedbackDrawerTitle, FeedbackDrawerValue } from './feedback.drawer';
import { useFeedbackDrawerContext } from './feedback.drawer.ctx';

export const FeedbackDrawerDetails = observer(() => {
	const { selectedItem } = useFeedbackDrawerContext();
	if (!selectedItem) return null;

	return (
		<Col gap={1}>
			<FeedbackDrawerItem>
				<FeedbackDrawerTitle>Status:</FeedbackDrawerTitle>
				<FeedbackDrawerValue>{selectedItem?.status}</FeedbackDrawerValue>
			</FeedbackDrawerItem>
			<FeedbackDrawerItem>
				<FeedbackDrawerTitle>Message:</FeedbackDrawerTitle>
				<FeedbackDrawerValue>{selectedItem?.message}</FeedbackDrawerValue>
			</FeedbackDrawerItem>
			{selectedItem?.statusChangedBy && (
				<>
					<FeedbackDrawerItem>
						<FeedbackDrawerTitle>Status changed by:</FeedbackDrawerTitle>
						<FeedbackDrawerValue>{selectedItem?.statusChangedBy}</FeedbackDrawerValue>
					</FeedbackDrawerItem>
					<FeedbackDrawerItem>
						<FeedbackDrawerTitle>Status changed at:</FeedbackDrawerTitle>
						<FeedbackDrawerValue>
							{new Date(selectedItem?.statusChangedAt ?? 0).toLocaleString()}
						</FeedbackDrawerValue>
					</FeedbackDrawerItem>
				</>
			)}
		</Col>
	);
});
